import { Race, ScoredRace, ScoredRunner, RunnerTag } from '../types/races';

export const processSystemRaces = (races: Race[], options?: { minFavouriteOdds?: number }): ScoredRace[] => {
  const minFavouriteOdds = options?.minFavouriteOdds ?? 1.80;
  return races.map((race) => processSystemRace(race, minFavouriteOdds));
};

function processSystemRace(race: Race, minFavouriteOdds: number): ScoredRace {
  const numRunners = race.runners.length;
  
  // Check if race has valid number of runners (4-12)
  if (numRunners < 4 || numRunners > 12) {
    return {
      ...race,
      runners: race.runners.map(runner => ({
        ...runner,
        tag: 'Does Not Qualify'
      })),
      tag: 'Does Not Qualify'
    };
  }

  // Sort runners by odds to find favourite and second favourite
  const sortedRunners = [...race.runners].sort((a, b) => {
    const aOdds = a.odds?.best_back?.price || Infinity;
    const bOdds = b.odds?.best_back?.price || Infinity;
    return aOdds - bOdds;
  });

  const favourite = sortedRunners[0];
  const secondFavourite = sortedRunners[1];

  if (!favourite.odds?.best_back || !secondFavourite.odds?.best_back) {
    return {
      ...race,
      runners: race.runners.map(runner => ({
        ...runner,
        tag: 'Does Not Qualify'
      })),
      tag: 'Does Not Qualify'
    };
  }

  // Check if favourite's odds are too low (strategy-aware minimum)
  const favouriteOdds = favourite.odds.best_back.price;
  if (favouriteOdds < minFavouriteOdds) {
    return {
      ...race,
      runners: race.runners.map(runner => ({
        ...runner,
        tag: 'Does Not Qualify'
      })),
      tag: 'Does Not Qualify'
    };
  }

  // Check odds difference (minimum 18%)
  const secondFavouriteOdds = secondFavourite.odds.best_back.price;
  const oddsDifference = ((secondFavouriteOdds - favouriteOdds) / favouriteOdds) * 100;

  if (oddsDifference < 18) {
    return {
      ...race,
      runners: race.runners.map(runner => ({
        ...runner,
        tag: 'Does Not Qualify'
      })),
      tag: 'Does Not Qualify'
    };
  }

  // If we get here, the race qualifies
  const processedRunners = race.runners.map(runner => ({
    ...runner,
    tag: runner.selectionId === favourite.selectionId ? ('Strong Favourite' as RunnerTag) : ('Does Not Qualify' as RunnerTag)
  }));

  return {
    ...race,
    runners: processedRunners,
    tag: 'Qualifying Race'
  };
}

// Helper function to count unique venues
export const countUniqueVenues = (races: Race[]): number => {
  const venues = new Set(races.map(race => race.event.venue));
  return venues.size;
}; 